import { render, staticRenderFns } from "./BaseTagInput.vue?vue&type=template&id=6ea711f3&"
import script from "./BaseTagInput.vue?vue&type=script&lang=js&"
export * from "./BaseTagInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports